import React from 'react';
import './ConnectorShell.css';

interface ConnectorEmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  action?: React.ReactNode;
  variant?: 'default' | 'info';
}

const ConnectorEmptyState: React.FC<ConnectorEmptyStateProps> = ({
  icon = 'fa-info-circle',
  title,
  description,
  action,
  variant = 'info',
}) => {
  return (
    <div className={`connector-empty-state connector-empty-state--${variant}`}>
      <div className="connector-empty-state__icon">
        <i className={`fas ${icon}`} aria-hidden="true" />
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      {action}
    </div>
  );
};

export default ConnectorEmptyState;
